import Loadable from 'react-loadable'

const CurationStation = Loadable({
    loader: () => import(/* webpackChunkName: "curationStation" */ './components/curation-station'),
    loading: () => null,
})

const CurationStationRoute = props => <CurationStation {...props} />

export default CurationStationRoute
